import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  const handleSubscribe = () => {
    // Track Subscribe event with Facebook Pixel
    if (window.fbq) {
      window.fbq('track', 'Subscribe', {
        source: 'cta_section',
        value: 1,
        currency: 'USD'
      });
    }
    window.open('https://t.me/sinyalbankentry/12328', '_blank');
  };

  return (
    <section className="py-20 bg-gradient-to-b from-black to-[#1a1a1a] text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Siap Tinggalkan Loss dan Mulai <span className="text-[#ED1C24]">Profit Konsisten</span>?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Bergabung dengan ribuan trader yang udah merasakan bedanya trading pakai Indikator SBE
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={handleSubscribe}
              className="bg-[#ED1C24] hover:bg-[#c91820] text-white px-8 py-6 text-lg font-semibold rounded-lg transition-all hover:scale-105 shadow-lg shadow-[#ED1C24]/50"
            >
              Join Sekarang
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;